<div class="container-fluid">
      <div class="card">
        <!-- <h3 class="h3">Create Your Organization</h3> -->
      <!--OLD FORM MOVE FUNCTION TO THE NEW ONE -->
        <form #profileForm="ngForm" class="form-control-wrapper" (ngSubmit)="onOrganizationCreateSubmit()">
          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.name' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.namehelp' | trans }}</p> 
            </div>
          </div>

          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.organizationname"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.description' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.descriptionhelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.orgdesc"/>  
          </div>
          
          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.email' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.emailhelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.email"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.website' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.websitehelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.www"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.phonenumber' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.phonenumberhelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.phone"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.address' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.addresshelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.address"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.address2' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.address2help' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.address2"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.zip' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.ziphelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.zip"/>  
          </div>


          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.city' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.cityhelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.city"/>  
          </div>

          <div class="row header-row">
            <div class="col">
              <label for="orgName">{{ 'orgadd.country' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.countryhelp' | trans }}</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.country"/>  
          </div>

          <div class="row header-row">
            <div class="col-auto">
              <label for="orgName">{{ 'orgadd.modules' | trans }}</label>
            </div>
            <div class="col">
              <p class="help">{{ 'orgadd.moduleshelp' | trans }} projects, planning, portal.</p> 
            </div>
          </div>
          <div class="row input-row">
            <input type="text" class="form-control" id="modules" name="modules" [(ngModel)]="organization.modules"/>  
          </div>
<!---
            <div class="form-group">
                <label for="orgName">Name</label>
                <p class="help">Enter the Name of your organization</p> 
                <input type="text" class="form-control" id="orgName" name="name" [(ngModel)]="organization.organizationname"/>  
                
            </div>
            <div class="form-group">
              <label for="orgDesc">Organization Description</label>
              <p class="help">Description of the organization</p> 
              <textarea class="form-control" rows="4" id="orgDesc" name="orgDesc" [(ngModel)]="organization.orgdesc"></textarea>
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <p class="help">Description of the organization</p> 
              <input class="form-control" rows="4" id="email" name="email" [(ngModel)]="organization.email"/>
            </div>
            <div class="form-group">
              <label for="www">www
              </label>
              <p class="help">Description of the organization</p> 
              <input class="form-control" rows="4" id="www" name="www" [(ngModel)]="organization.www"/>
            </div>
            <div class="form-group">
              <label for="phone">Phone</label>
              <p class="help">Description of the organization</p> 
              <input class="form-control" rows="4" id="phone" name="phone" [(ngModel)]="organization.phone"/>
            </div>
            <div class="form-group">
                <label for="address">Address</label>
                <p class="help">Description of the organization</p> 
                <input class="form-control" rows="4" id="address" name="address" [(ngModel)]="organization.address"/>
              </div>
              <div class="form-group">
                <label for="address2">Address2</label>
                <p class="help">Description of the organization</p> 
                <input class="form-control" rows="4" id="address2" name="address2" [(ngModel)]="organization.address2"/>
              </div>
              <div class="form-group">
                <label for="zip">Zip</label>
                <p class="help">Description of the organization</p> 
                <input class="form-control" rows="4" id="zip" name="zip" [(ngModel)]="organization.zip"/>
              </div>
              <div class="form-group">
                <label for="city">City</label>
                <p class="help">Description of the organization</p> 
                <input class="form-control" rows="4" id="city" name="city" [(ngModel)]="organization.city"/>
              </div>
              <div class="form-group">
                <label for="country">Country</label>
                <p class="help">Description of the organization</p> 
                <input class="form-control" rows="4" id="country" name="country" [(ngModel)]="organization.country"/>
              </div>
              <div class="form-group">
                <label for="modules">Worktrest modules</label>
                <p class="help">list of modules activated for this organization. Values can be none, one or more of these: projects, planning, portal. </p> 
                <input class="form-control" rows="4" id="modules" name="modules" [(ngModel)]="organization.modules"/>
              </div>
            -->
            <button type="submit" class="btn btn-primary w-100 p-2"><h6 class="button-text">{{ 'orgadd.createorg' | trans }}</h6></button>
          
          </form>
          
          <!--
          <form>
            <div class="form-row">
              <div class="container">
                <label for="validationServer01">Organization Name</label>
                <input class="ordaddtop1" type="text" class="form-control is-valid" id="validationServer01" placeholder="First name" value="Mark" required>
                <div class="valid-feedback">
                  Looks good!
                </div>
              </div>
              <div class="container">
                <label for="validationServer02">Tagline</label>
                <input type="text" class="form-control is-valid" id="validationServer02" placeholder="Last name" value="Otto" required>
                <div class="valid-feedback">
                  Looks good!
                </div>
              </div>
              
            </div>
            <div class="form-row">
              <div class="container">
                <label for="validationServer01">Organization Description</label>
                <input type="text" class="form-control is-valid" id="validationServer01" placeholder="Organization Description" value="Your organization Description" required>
                <div class="valid-feedback">
                  Looks good!
                </div>
              </div>
              <div class="container">
                <label for="validationServer02">Website</label>
                <input type="text" class="form-control is-valid" id="validationServer02" placeholder="Website" value="Webiste" required>
                <div class="valid-feedback">
                  Looks good!
                </div>
              </div>
            </div>
            <div class="form-row rowcustom">
              <div class="col-md-4 mb-4">
                <label for="validationServer03">Email</label>
                <input type="text" class="form-control is-invalid" id="validationServer03" placeholder="Email" required>
                <div class="invalid-feedback">
                  Please provide a valid email.
                </div>
              </div>
              <div class="col"></div>
              <div class="col-md-3 mb-3">
                <label for="validationServer04">Phone</label>
                <input type="text" class="form-control is-invalid" id="validationServer04" placeholder="Phone" required>
                <div class="invalid-feedback">
                  Please provide a valid phone number.
                </div>
              </div>
              <div class="col"></div>
              <div class="col-md-3 mb-3">
                <label for="validationServer05">Country</label>
                <input type="text" class="form-control is-invalid" id="validationServer05" placeholder="Country" required>
                <div class="invalid-feedback">
                  Please provide a valid country.
                </div>
              </div>
            </div>
          
            <div class="form-row rowcustom">
              <div class="col-md-4 mb-4">
                <label for="validationServer03">City</label>
                <input type="text" class="form-control is-invalid" id="validationServer03" placeholder="City" required>
                <div class="invalid-feedback">
                  Please provide a valid city.
                </div>
              </div>
              <div class="col"></div>
              <div class="col-md-3 mb-3">
                <label for="validationServer04">State</label>
                <input type="text" class="form-control is-invalid" id="validationServer04" placeholder="State" required>
                <div class="invalid-feedback">
                  Please provide a valid state.
                </div>
              </div>
              <div class="col"></div>
              <div class="col-md-3 mb-3">
                <label for="validationServer05">Zip</label>
                <input type="text" class="form-control is-invalid" id="validationServer05" placeholder="Zip" required>
                <div class="invalid-feedback">
                  Please provide a valid zip.
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input is-invalid" type="checkbox" value="" id="invalidCheck3" required>
                <label class="form-check-label" for="invalidCheck3">
                  Agree to terms and conditions
                </label>
                <div class="invalid-feedback">
                  You must agree before submitting.
                </div>
              </div>
            </div>
            <button class="btn btn-primary" type="submit">Submit form</button>
          </form>-->
        </div>
    </div>    